export default __webpack_public_path__ + "487edbdbf7118e9ed034cac695cfb413.mp3";